export default "__VITE_ASSET__4fa30c5a__"